'use client'

import { useAuthContext } from '@/contexts/AuthContext'
import { trackOnboardingMilestoneForUser } from '@/lib/activityClient'
import { roboto } from '@/lib/fonts'
import { Language } from '@/lib/interfaces/interfaces'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'

interface Props{
	barEmail: string
  language: Language
}

const EditMenuButton = ({ barEmail, language } : Props) => {
  const { user } = useAuthContext()

  const [showButton, setShowButton] = useState(false)

  // Hito `visitedPublicMenuFirstTimeAt`: si quien visita el menú público
  // es el propio dueño (mismo gate que muestra el botón EDITAR), lo
  // reportamos. Una sola vez por mount (ref); el endpoint dedupica por
  // bar y además deja traza `owner_viewed_public_menu` en el activity
  // log en cada visita. Fire-and-forget: nunca bloquea el menú.
  const hasTrackedVisit = useRef(false)

  useEffect(() => {
    if (user?.email === barEmail) {
      setShowButton(true)
      if (!hasTrackedVisit.current) {
        hasTrackedVisit.current = true
        trackOnboardingMilestoneForUser(user, 'visitedPublicMenuFirstTimeAt')
      }
    }
  }, [barEmail, user])

  if (showButton) {
    return (
      <div className='edit-menu-button'>
        <Link style={roboto.style} href='/dashboard/digital-menu'>
          <FontAwesomeIcon icon={faEdit} /> {language === 'es' ? 'EDITAR' : 'EDIT'}
        </Link>
      </div>
    )
  } else {
    return null
  }
}
export default EditMenuButton
